import './WinnerBanner.css';

function WinnerBanner(props) {
  return (
    <div className="banner">
      {props.name ? "win: " + props.name + "🎉" : ""}
    </div>
  );
}

export default WinnerBanner;